import styled from 'styled-components';
import { colorShade } from '../../utils/style';
import Tooltip from '../Tooltip/Tooltip';
import ProgressLiquid from './ProgressLiquid';

interface ProgressDotProps {
    value?: number | 'indeterminate'
}

export default function ProgressDot({ value = 100 }: ProgressDotProps) {
    return (
        <Tooltip naked={true} content={
            <TooltipWrapper>
                <ProgressLiquid value={value} className='progress-dot-tooltip-bg' width='100%' />
                <div className='progress-dot-tooltip-content'>
                    <div className='progress-dot-tooltip-title'>Loading</div>

                    <div className='progress-dot-tooltip-progress'>
                        <div className='progress-dot-tooltip-value'>{value === 'indeterminate' ? 'Loading...' : `${value}%`}</div>

                        <div className='progress-dot-tooltip-time'>Aprox. 3min</div>
                    </div>

                    {/* //TODO add bar */}
                </div>

            </TooltipWrapper>
        }>
            <Wrapper>
                <div className='progress-dot' />
            </Wrapper>
        </Tooltip>

    )
}

const TooltipWrapper = styled.div`
    display: grid;
    min-width: 60px;
    grid-template-columns: 120px;

    .progress-dot-tooltip-bg {
        grid-area: 1 / 1;
    }

    .progress-dot-tooltip-content {
        grid-area: 1 / 1;
        padding: 10px;
        z-index: 10;
        display: flex;
        flex-direction: column;
    }

    .progress-dot-tooltip-title {
        font-size: 11px;
        /* opacity: 0.6; */
        font-weight: 700;
        text-align: center;
        color: #ddd;
    }

    .progress-dot-tooltip-progress {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 10px 0;
        flex-grow: 1;
    }

    .progress-dot-tooltip-value {
        font-weight: 700;
        font-size: 18px;
        text-align: center;
        
    }
    
    .progress-dot-tooltip-time {
        font-size: 11px;
        font-weight: 700;
        text-align: center;
        color: #ddd;
    }
`

const Wrapper = styled.div`
    width: 24px;
    height: 24px;
    padding: 5px;

    display: flex;
    align-items: center;

    .progress-dot {
        min-width: 14px;
        min-height: 14px;
        border-radius: 50%;
        background-color: ${props => colorShade(props.theme.primaryColor, 0.1)};
        animation: blink 1.5s infinite ;
    }


    @keyframes blink {
        0% {opacity: 0.3}
        50% {opacity: 1}
        100% {opacity: 0.3}
    }
`